module.exports = __webpack_public_path__ + "static/img/アセット 40@2x.bffa5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 40@2x.png
// module id = sQt4
// module chunks = 1